export const RESELLER_LOGIN_REQUEST = "RESELLER_LOGIN_REQUEST";
export const RESELLER_LOGIN_SUCCESS = "RESELLER_LOGIN_SUCCESS";
export const RESELLER_LOGIN_FAIL = "RESELLER_LOGIN_FAIL";


export const REGISTER_RESELLER_USER_REQUEST = "REGISTER_RESELLER_USER_REQUEST";
export const REGISTER_RESELLER_USER_SUCCESS = "REGISTER_RESELLER_USER_SUCCESS";
export const REGISTER_RESELLER_USER_FAIL = "REGISTER_RESELLER_USER_FAIL";

export const RESELLER_LOGOUT_SUCCESS = "RESELLER_LOGOUT_SUCCESS";
export const RESELLER_LOGOUT_FAIL = "RESELLER_LOGOUT_FAIL";

export const LOAD_RESELLER_USER_REQUEST = "LOAD_RESELLER_USER_REQUEST";
export const LOAD_RESELLER_USER_SUCCESS = "LOAD_RESELLER_USER_SUCCESS";
export const LOAD_RESELLER_USER_FAIL = "LOAD_RESELLER_USER_FAIL";

export const ALL_RESELLER_USERS_REQUEST = "ALL_RESELLER_USERS_REQUEST";
export const ALL_RESELLER_USERS_SUCCESS = "ALL_USERS_SUCCESS";
export const ALL_RESELLER_USERS_FAIL = "ALL_RESELLER_USERS_FAIL";
export const ALL_RESELLER_USERS_RESET = "ALL_RESELLER_USERS_RESET";


export const UPDATE_RESELLER_USER_REQUEST = "UPDATE_RESELLER_USER_REQUEST";
export const UPDATE_RESELLER_USER_SUCCESS = "UPDATE_RESELLER_USER_SUCCESS";
export const UPDATE_RESELLER_USER_RESET = "UPDATE_RESELLER_USER_RESET";
export const UPDATE_RESELLER_USER_FAIL = "UPDATE_RESELLER_USER_FAIL";

export const DELETE_RESELLER_USER_REQUEST = "DELETE_RESELLER_USER_REQUEST";
export const DELETE_RESELLER_USER_SUCCESS = "DELETE_RESELLER_USER_SUCCESS";
export const DELETE_RESELLER_USER_FAIL = "DELETE_RESELLER_USER_FAIL";

export const USER_RESELLER_ROLE_REQUEST = "USER_RESELLER_ROLE_REQUEST";
export const USER_RESELLER_ROLE_SUCCESS = "USER_RESELLER_ROLE_SUCCESS";
export const USER_RESELLER_ROLE_FAIL = "USER_RESELLER_ROLE_FAIL";

